import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import { useToast } from "@hooks"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import {adminSkuRowViewedMappings, adminSkuSavingData, isReloadAdminSkuData} from "../@signals"


export default function useAdminSkuFilters() {
    const { showToast } = useToast()

    const localData = useSignal([])

    useEffect(() => {
        if (isLoadingCommonFilters.value)
            handleSubmit()
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (isReloadAdminSkuData.value) {
            localData.value = [...adminSkuSavingData.value]
            isReloadAdminSkuData.value = false
        }
    }, [isReloadAdminSkuData.value])

    const handleSubmit = () => {
        adminSkuRowViewedMappings.value = {}
        postSubmit(`${BACKEND_APIS.ADMIN}/sku/context`, commonFiltersValue.value).then(({ data }) => {
            isLoadingCommonFilters.value = false
            localData.value = data
            adminSkuSavingData.value = data
        }).catch(() => {
            showToast.error()
            isLoadingCommonFilters.value = false
        })
    }

    return {
        data: localData.value,
        isLoading: isLoadingCommonFilters.value,
    }
}